<template>
  <PlacementsPill
    :total="column.hiresCount"
    :active="column.activeHiresCount"
    :all-url="allUrl"
    :active-url="activeUrl"
    :total-data-test="`client-placements-${rowIndex}`"
    :active-data-test="`client-active-placements-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { HireActiveStatus } from '@/gql/graphql'
import { clientPlacementsUrl } from '@/components/Clients/placementFilters'
import PlacementsPill from '@/components/Clients/PlacementsPill.vue'

const ClientPlacementsColumn = graphql(`
  fragment ClientPlacementsColumn on CompanySupplier {
    id
    hiresCount
    activeHiresCount: hiresCount(status: [ACTIVE])
    company {
      id
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ClientPlacementsColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(ClientPlacementsColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const allUrl = computed(() => clientPlacementsUrl(column.value.company))
const activeUrl = computed(() =>
  clientPlacementsUrl(column.value.company, [HireActiveStatus.Active]),
)
</script>
